// extracted by css-extract-rspack-plugin
export default {"Text":"Description-module__Text__E6q8NM2","Box":"Description-module__Box__J5HnMQs"};